"use strict";

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ldflex = require("ldflex");

var _dataModel = require("@rdfjs/data-model");

var _context = _interopRequireDefault(require("./context.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _awaitAsyncGenerator(value) {
  return new _AwaitValue(value);
}

function _wrapAsyncGenerator(fn) {
  return function () {
    return new _AsyncGenerator(fn.apply(this, arguments));
  };
}

function _AsyncGenerator(gen) {
  var front, back;

  function send(key, arg) {
    return new Promise(function (resolve, reject) {
      var request = {
        key: key,
        arg: arg,
        resolve: resolve,
        reject: reject,
        next: null
      };

      if (back) {
        back = back.next = request;
      } else {
        front = back = request;
        resume(key, arg);
      }
    });
  }

  function resume(key, arg) {
    try {
      var result = gen[key](arg);
      var value = result.value;
      var wrappedAwait = value instanceof _AwaitValue;
      Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) {
        if (wrappedAwait) {
          resume("next", arg);
          return;
        }

        settle(result.done ? "return" : "normal", arg);
      }, function (err) {
        resume("throw", err);
      });
    } catch (err) {
      settle("throw", err);
    }
  }

  function settle(type, value) {
    switch (type) {
      case "return":
        front.resolve({
          value: value,
          done: true
        });
        break;

      case "throw":
        front.reject(value);
        break;

      default:
        front.resolve({
          value: value,
          done: false
        });
        break;
    }

    front = front.next;

    if (front) {
      resume(front.key, front.arg);
    } else {
      back = null;
    }
  }

  this._invoke = send;

  if (typeof gen.return !== "function") {
    this.return = undefined;
  }
}

if (typeof Symbol === "function" && Symbol.asyncIterator) {
  _AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
    return this;
  };
}

_AsyncGenerator.prototype.next = function (arg) {
  return this._invoke("next", arg);
};

_AsyncGenerator.prototype.throw = function (arg) {
  return this._invoke("throw", arg);
};

_AsyncGenerator.prototype.return = function (arg) {
  return this._invoke("return", arg);
};

function _AwaitValue(value) {
  this.wrapped = value;
}

function _asyncIterator(iterable) {
  var method;

  if (typeof Symbol !== "undefined") {
    if (Symbol.asyncIterator) {
      method = iterable[Symbol.asyncIterator];
      if (method != null) return method.call(iterable);
    }

    if (Symbol.iterator) {
      method = iterable[Symbol.iterator];
      if (method != null) return method.call(iterable);
    }
  }

  throw new TypeError("Object is not async iterable");
}

var as = _context.default['@context'].as;
/**
 * Base class for handlers that manipulate activities
 * Requires:
 * - the `root.user` handler
 * - the `root[...]` resolver
 * - a queryEngine property in the path settings
 */

var ActivityHandler =
/*#__PURE__*/
function () {
  function ActivityHandler() {
    _classCallCheck(this, ActivityHandler);

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$activitiesPath = _ref.activitiesPath,
        activitiesPath = _ref$activitiesPath === void 0 ? '/public/activities' : _ref$activitiesPath;

    _defineProperty(this, "requireUser", true);

    this.activitiesPath = activitiesPath;
  }

  _createClass(ActivityHandler, [{
    key: "handle",
    value: function handle(pathData, path) {
      var self = this;
      var root = path.root;
      var queryEngine = pathData.settings.queryEngine; // Return an iterator over the activity paths

      return function () {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "".concat(as, "Like");
        return (0, _ldflex.toIterablePromise)(
        /*#__PURE__*/
        _wrapAsyncGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var user, storage, document, results, actor, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, object, activity, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, result, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, term;

          return _regeneratorRuntime.wrap(function _callee$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return _awaitAsyncGenerator(root.user);

                case 3:
                  user = _context2.sent;
                  _context2.next = 11;
                  break;

                case 6:
                  _context2.prev = 6;
                  _context2.t0 = _context2["catch"](0);

                  if (!self.requireUser) {
                    _context2.next = 10;
                    break;
                  }

                  throw _context2.t0;

                case 10:
                  return _context2.abrupt("return");

                case 11:
                  _context2.next = 13;
                  return _awaitAsyncGenerator(root.user.pim$storage);

                case 13:
                  storage = _context2.sent;
                  document = new URL(self.activitiesPath, storage || user).href; // Obtain results for every activity on the path

                  results = [];
                  actor = (0, _dataModel.namedNode)(user);
                  type = (0, _dataModel.namedNode)(type);
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _context2.prev = 20;
                  _iterator = _asyncIterator(path);

                case 22:
                  _context2.next = 24;
                  return _awaitAsyncGenerator(_iterator.next());

                case 24:
                  _step = _context2.sent;
                  _iteratorNormalCompletion = _step.done;
                  _context2.next = 28;
                  return _awaitAsyncGenerator(_step.value);

                case 28:
                  _value = _context2.sent;

                  if (_iteratorNormalCompletion) {
                    _context2.next = 69;
                    break;
                  }

                  object = _value;

                  if (!(object.termType === 'NamedNode')) {
                    _context2.next = 66;
                    break;
                  }

                  activity = {
                    actor: actor,
                    type: type,
                    object: object
                  };
                  _iteratorNormalCompletion2 = true;
                  _didIteratorError2 = false;
                  _context2.prev = 35;
                  _iterator2 = _asyncIterator(self.createResults(activity, document, queryEngine));

                case 37:
                  _context2.next = 39;
                  return _awaitAsyncGenerator(_iterator2.next());

                case 39:
                  _step2 = _context2.sent;
                  _iteratorNormalCompletion2 = _step2.done;
                  _context2.next = 43;
                  return _awaitAsyncGenerator(_step2.value);

                case 43:
                  _value2 = _context2.sent;

                  if (_iteratorNormalCompletion2) {
                    _context2.next = 50;
                    break;
                  }

                  result = _value2;
                  results.push(result);

                case 47:
                  _iteratorNormalCompletion2 = true;
                  _context2.next = 37;
                  break;

                case 50:
                  _context2.next = 56;
                  break;

                case 52:
                  _context2.prev = 52;
                  _context2.t1 = _context2["catch"](35);
                  _didIteratorError2 = true;
                  _iteratorError2 = _context2.t1;

                case 56:
                  _context2.prev = 56;
                  _context2.prev = 57;

                  if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                    _context2.next = 61;
                    break;
                  }

                  _context2.next = 61;
                  return _awaitAsyncGenerator(_iterator2.return());

                case 61:
                  _context2.prev = 61;

                  if (!_didIteratorError2) {
                    _context2.next = 64;
                    break;
                  }

                  throw _iteratorError2;

                case 64:
                  return _context2.finish(61);

                case 65:
                  return _context2.finish(56);

                case 66:
                  _iteratorNormalCompletion = true;
                  _context2.next = 22;
                  break;

                case 69:
                  _context2.next = 75;
                  break;

                case 71:
                  _context2.prev = 71;
                  _context2.t2 = _context2["catch"](20);
                  _didIteratorError = true;
                  _iteratorError = _context2.t2;

                case 75:
                  _context2.prev = 75;
                  _context2.prev = 76;

                  if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                    _context2.next = 80;
                    break;
                  }

                  _context2.next = 80;
                  return _awaitAsyncGenerator(_iterator.return());

                case 80:
                  _context2.prev = 80;

                  if (!_didIteratorError) {
                    _context2.next = 83;
                    break;
                  }

                  throw _iteratorError;

                case 83:
                  return _context2.finish(80);

                case 84:
                  return _context2.finish(75);

                case 85:
                  _iteratorNormalCompletion3 = true;
                  _didIteratorError3 = false;
                  _iteratorError3 = undefined;
                  _context2.prev = 88;
                  _context2.next = 91;
                  return _awaitAsyncGenerator(self.processResults(results, document, queryEngine));

                case 91:
                  _context2.t3 = Symbol.iterator;
                  _iterator3 = _context2.sent[_context2.t3]();

                case 93:
                  if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                    _context2.next = 100;
                    break;
                  }

                  term = _step3.value;
                  _context2.next = 97;
                  return root[term.value];

                case 97:
                  _iteratorNormalCompletion3 = true;
                  _context2.next = 93;
                  break;

                case 100:
                  _context2.next = 106;
                  break;

                case 102:
                  _context2.prev = 102;
                  _context2.t4 = _context2["catch"](88);
                  _didIteratorError3 = true;
                  _iteratorError3 = _context2.t4;

                case 106:
                  _context2.prev = 106;
                  _context2.prev = 107;

                  if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return();
                  }

                case 109:
                  _context2.prev = 109;

                  if (!_didIteratorError3) {
                    _context2.next = 112;
                    break;
                  }

                  throw _iteratorError3;

                case 112:
                  return _context2.finish(109);

                case 113:
                  return _context2.finish(106);

                case 114:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee, null, [[0, 6], [20, 71, 75, 85], [35, 52, 56, 66], [57,, 61, 65], [76,, 80, 84], [88, 102, 106, 114], [107,, 109, 113]]);
        })));
      };
    }
  }, {
    key: "processResults",
    value: function () {
      var _processResults = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(results) {
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", results);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2);
      }));

      function processResults(_x) {
        return _processResults.apply(this, arguments);
      }

      return processResults;
    }()
  }]);

  return ActivityHandler;
}();

exports.default = ActivityHandler;